var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "./Routes.constants.js";
var TaskPivots = /* @__PURE__ */ ((TaskPivots2) => {
  TaskPivots2["details"] = "details";
  TaskPivots2["logs"] = "logs";
  return TaskPivots2;
})(TaskPivots || {});
class Util {
  constructor() {
    __publicField(this, "_modulePath", ROUTES.analysis.root.match.path);
    __publicField(this, "_modulePathname", ROUTES.analysis.root.location.pathname);
    __publicField(this, "routes", {
      root: {
        path: () => `${this.path}`,
        url: (payload) => {
          const { stepId } = payload;
          return `${this.url}/${stepId}`;
        }
      },
      list: {
        path: () => `${this.path}${ROUTES.analysis.list.match.path}`,
        url: (payload) => {
          const { stepId, studyId, scorecardId } = payload;
          if (!stepId) {
            return "";
          }
          let path = `${this.url}/${stepId}`;
          const params = [];
          if (studyId) {
            params.push(`highlight=${studyId}`);
          }
          if (scorecardId) {
            params.push(`scorecardId=${scorecardId}`);
          }
          if (params.length) {
            path += `?${params.join("&")}`;
          }
          return `${path}`;
        }
      },
      create: {
        path: () => `${this.path}${ROUTES.analysis.create.match.path}`,
        url: (payload) => {
          const { stepId } = payload;
          return `${this.url}${ROUTES.analysis.create.location.pathname}/${stepId}/create`;
        }
      },
      clone: {
        path: () => `${this.path}${ROUTES.analysis.clone.match.path}`,
        url: (payload) => {
          const { stepId, studyId } = payload;
          return `${this.url}${ROUTES.analysis.clone.location.pathname}/${stepId}/study/${studyId}/clone`;
        }
      },
      view: {
        path: () => `${this.path}${ROUTES.analysis.view.match.path}`,
        url: (payload) => {
          const { stepId, studyId, taskId, taskPivot, scorecardId, showParameters } = payload;
          if (!stepId) {
            return "";
          }
          const pathParts = [`${this.url}/${stepId}`];
          if (studyId) {
            pathParts.push(`study/${studyId}`);
            if (taskId) {
              pathParts.push(`task/${taskId}`);
              if (taskPivot) {
                pathParts.push(taskPivot);
              }
            }
          }
          if (showParameters) {
            pathParts.push(`parameters`);
          }
          return pathParts.join("/");
        }
      },
      scorecardTask: {
        path: () => `${this.path}${ROUTES.analysis.scorecardTask.match.path}`,
        url: (payload) => {
          const { scorecardId } = payload;
          return `${this.url}${ROUTES.analysis.scorecardTask.location.pathname}/${scorecardId}`;
        }
      }
    });
  }
  /**
   * React Router regex path
   */
  get path() {
    return `${NavigationService.root.path}${this._modulePath}`;
  }
  /**
   * Pathname used to construct complete URL
   */
  get url() {
    return `${NavigationService.root.url}${this._modulePathname}`;
  }
}
const AnalysisRouteUtils = new Util();
export {
  AnalysisRouteUtils,
  TaskPivots
};
//# sourceMappingURL=AnalysisRoute.utils.js.map
